var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 63,
    viewBox: "0 0 82 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.36 0H1.64C0.73472 0 0 0.73472 0 1.64V60.68C0 61.5869 0.73472 62.32 1.64 62.32H80.36C81.2669 62.32 82 61.5869 82 60.68V1.64C82 0.73472 81.2669 0 80.36 0ZM78.72 3.28V35.5831L62.0445 10.5698C61.728 10.0926 61.1671 9.81868 60.6078 9.84164C60.0322 9.86788 59.5156 10.191 59.2401 10.6944L40.2161 45.5707L21.8382 39.4453C21.3594 39.2813 20.8313 39.3534 20.4098 39.6355L3.28 51.0565V3.28H78.72ZM3.28 59.04V54.9974L21.5627 42.8089L40.4818 49.1147C41.2345 49.3673 42.0594 49.0426 42.4399 48.3439L60.821 14.6468L78.72 41.4969V59.04H3.28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3172 29.5201C25.8387 29.5201 29.5172 25.8416 29.5172 21.3201C29.5172 16.7986 25.8387 13.1201 21.3172 13.1201C16.7957 13.1201 13.1172 16.7986 13.1172 21.3201C13.1172 25.8416 16.7957 29.5201 21.3172 29.5201ZM21.3172 16.4001C24.0297 16.4001 26.2372 18.6076 26.2372 21.3201C26.2372 24.0327 24.0297 26.2401 21.3172 26.2401C18.6046 26.2401 16.3972 24.0327 16.3972 21.3201C16.3972 18.6076 18.6046 16.4001 21.3172 16.4001Z",
    fill: "#188F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageType);
export default __webpack_public_path__ + "static/media/image_type.e08c499c674476613ee2d20c2aeec9df.svg";
export { ForwardRef as ReactComponent };